import script from "./DashboardContentLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardContentLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardContentLayout.vue?vue&type=style&index=0&id=fd9aa5b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd9aa5b4"]])

export default __exports__